module.exports = __webpack_public_path__ + "static/media/showcase-2.0e0854e9.jpg";